"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.byEnvironment = void 0;
/**
 * 動作環境に応じた定数を取得する
 *
 * #### インポート
 * ```typescript
 * import { byEnvironment } from 'rj_frontend_common/dist/api/common/constants';
 * ```
 * @param environment 動作環境ごとの定数
 * @returns 動作環境に応じた定数
 */
const byEnvironment = (environment) => environment[process.env.REACT_APP_ENVIRONMENT];
exports.byEnvironment = byEnvironment;
